const AUTH_API_FAILURE_KEY = 'auth_api_failure';

export type AuthApiFailure = {
  status: number;
  url: string;
  method?: string;
  message: string;
  at: string;
};

export const AUTH_ERROR_QUERY_PARAM = 'authError';

export const saveAuthApiFailure = (failure: Omit<AuthApiFailure, 'at'>): void => {
  const payload: AuthApiFailure = {
    ...failure,
    at: new Date().toISOString(),
  };
  try {
    sessionStorage.setItem(AUTH_API_FAILURE_KEY, JSON.stringify(payload));
  } catch {
    // sessionStorage puede fallar en modo privado estricto
  }
};

export const readAuthApiFailure = (): AuthApiFailure | null => {
  try {
    const raw = sessionStorage.getItem(AUTH_API_FAILURE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as AuthApiFailure;
  } catch {
    return null;
  }
};

export const clearAuthApiFailure = (): void => {
  try {
    sessionStorage.removeItem(AUTH_API_FAILURE_KEY);
  } catch {
    // ignore
  }
};

export const hasAuthApiFailure = (): boolean => readAuthApiFailure() !== null;

export const buildLoginAuthErrorUrl = (): string =>
  `/login?${AUTH_ERROR_QUERY_PARAM}=1`;

export const logAuthApiFailure = (failure: Omit<AuthApiFailure, 'at'>): void => {
  // eslint-disable-next-line no-console
  console.error('[auth] API rechazó la sesión', {
    status: failure.status,
    method: failure.method,
    url: failure.url,
    message: failure.message,
    origin: typeof window !== 'undefined' ? window.location.origin : undefined,
    pathname: typeof window !== 'undefined' ? window.location.pathname : undefined,
  });
};
